import { useMemo, useState } from "react";
import { PageHero } from "../components/primitives.jsx";
import { SpecPacket } from "../components/spec-packet.jsx";
import { patternPackets } from "../data/catalog.js";

const filters = ["all", "required", "recommended", "avoid"];

export function PatternsPage() {
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("all");

  const visible = useMemo(() => {
    const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
    return patternPackets.filter((packet) => {
      const statusMatch = status === "all" || packet.status === status;
      const haystack = [
        packet.title,
        packet.summary,
        packet.uri,
        packet.severity,
        packet.category,
        packet.tags.join(" "),
        packet.good,
        packet.bad,
        packet.sideEffects.join(" "),
        packet.verification.join(" ")
      ].join(" ").toLowerCase();
      const queryMatch = !tokens.length || tokens.every((token) => haystack.includes(token));
      return statusMatch && queryMatch;
    });
  }, [query, status]);

  return (
    <main>
      <PageHero eyebrow="Pattern bank" title="Search by architectural risk, not by buzzword.">
        <p>
          Each packet includes intent, bad and good practice, side effects, severity, verification
          steps, and protocol metadata for agent search.
        </p>
      </PageHero>

      <div className="filterbar" aria-label="Pattern filters">
        <div className="container filterbar__inner">
          <div className="filterbar__tabs" aria-label="Pattern status filters">
            {filters.map((item) => (
              <button
                key={item}
                className="tab"
                type="button"
                data-active={status === item ? "" : undefined}
                aria-pressed={status === item}
                onClick={() => setStatus(item)}
              >
                {item === "all" ? "All" : item[0].toUpperCase() + item.slice(1)}
              </button>
            ))}
          </div>
          <div className="filterbar__right">
            <div className="search">
              <span className="slash">/</span>
              <input
                type="search"
                autoComplete="off"
                placeholder="boundary leak, flaky test, adapter…"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                aria-label="Search the bank"
              />
            </div>
            <span className="lbl" role="status" aria-live="polite">
              {visible.length} packet{visible.length === 1 ? "" : "s"}
            </span>
          </div>
        </div>
      </div>

      <section className="container packet-list" aria-label="Architecture pattern packets">
        {visible.length ? (
          visible.map((packet) => <SpecPacket key={packet.id} packet={packet} />)
        ) : (
          <p className="packet-list__empty">
            No packets match. Clear the search or choose All to widen the result set.
          </p>
        )}
      </section>
    </main>
  );
}
